type WizardStep = 1 | 2 | 3;

export type CampaignCreationTelemetryEvent =
  | { name: "wizard_open"; step: WizardStep }
  | { name: "profile_selected"; step: 1; outcome: "connected" | "unavailable" }
  | { name: "step_navigation"; step: WizardStep; direction: "forward" | "back" | "edit" }
  | { name: "validation"; step: WizardStep; category: string }
  | { name: "products_added"; step: 2; method: "search" | "enter" | "bulk"; count: number }
  | { name: "create_click"; step: 3 }
  | {
      name: "terminal_result";
      step: 3;
      status: "succeeded" | "partial" | "failed" | "unknown";
      failedStep?: string;
    }
  | { name: "resume_click"; step: 3 }
  | { name: "cancel"; step: WizardStep }
  | { name: "campaign_detail_click"; step: 3 };

export type CampaignCreationTelemetrySink = (event: CampaignCreationTelemetryEvent) => void;
let sink: CampaignCreationTelemetrySink | null = null;

const ALLOWED_KEYS = new Set([
  "name",
  "step",
  "outcome",
  "direction",
  "category",
  "method",
  "count",
  "status",
  "failedStep",
]);

export function setCampaignCreationTelemetrySink(next: CampaignCreationTelemetrySink | null): void {
  sink = next;
}

export function emitCampaignCreationTelemetry(event: CampaignCreationTelemetryEvent): void {
  const safe = Object.fromEntries(
    Object.entries(event).filter(
      ([key, value]) =>
        ALLOWED_KEYS.has(key) &&
        (typeof value === "string" || typeof value === "number" || typeof value === "boolean"),
    ),
  ) as CampaignCreationTelemetryEvent;
  sink?.(safe);
}

/** Provider adapters must disable auto pageviews or use this static template. */
export const CAMPAIGN_RESULT_ROUTE_TEMPLATE = "/campaigns/new/:requestId";
